<template>
  <div>
    <div class="col-md-12">
      <ul class="list-group list-group-flush">
        <li class="row ts-flex">
          <div class="col-md-6 ts-py-1 list-group-item">
            <span>{{ $t('studentScoringEntry.academicYear') }} : </span>
            <p class="pull-right kh-font ts-font-bold">
              {{ classSelected ? classSelected.academic_year.ac_year : '-' }}
            </p>
          </div>
          <div class="col-md-6 ts-py-1 list-group-item">
            <span>{{ $t('studentScoringEntry.mainProgram') }} : </span>
            <p class="pull-right kh-font ts-font-bold">
              {{
                classSelected
                  ? classSelected.main_program.acp_name_foreign
                  : '-'
              }}
            </p>
          </div>
        </li>

        <li class="row ts-flex">
          <div class="col-md-6 ts-py-1 list-group-item">
            <span>{{ $t('studentScoringEntry.academicTerm') }} : </span>
            <p class="pull-right kh-font ts-font-bold">
              {{ classSelected ? classSelected.academic_term.term_name : '-' }}
            </p>
          </div>
          <div class="col-md-6 ts-py-1 list-group-item">
            <span>{{ $t('studentScoringEntry.className') }} : </span>
            <p class="pull-right kh-font ts-font-bold">
              {{ classSelected ? classSelected.class_name : '-' }}
            </p>
          </div>
        </li>

        <li class="row ts-flex">
          <div class="col-md-6 ts-py-1 list-group-item">
            <span>{{ $t('studentScoringEntry.scoringCycle') }} : </span>
            <p class="pull-right kh-font ts-font-bold">
              {{
                scoringCycleSelected
                  ? scoringCycleSelected.scoring_cycle_name
                  : '-'
              }}
            </p>
          </div>
          <div class="col-md-6 ts-py-1 list-group-item">
            <span>{{ $t('studentScoringEntry.scoringCycleValue') }} : </span>
            <p class="pull-right kh-font ts-font-bold">
              {{ cycleValueSelected ? cycleValueSelected : '-' }}
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'studentInfoEntry',
  props: ['value', 'classOperations', 'studentProfiles'],
  data() {
    return {
      model: {},
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    classSelected() {
      return this.classOperations.find(c => c.class_id == this.model.class_id)
    },
    scoringCycleSelected() {
      return this.$store.state.studentScoringEntry.scoring_cycles.find(
        c => c.scoring_cycle_id == this.model.scoring_cycle_id
      )
    },
    cycleValueSelected() {
      if (this.model.scoring_cycle_id !== 1) {
        if (this.model.cycle_value) {
          let scoring_cycle = this.$store.state.studentScoringEntry.scoring_cycle_values.find(
            s =>
              s.scoring_cycle_id == this.model.scoring_cycle_id &&
              s.scoring_cycle_value == this.model.cycle_value
          )
          return scoring_cycle ? scoring_cycle.scoring_cycle_description : ''
        }
      }
      return this.months[this.model.scoring_cycle_id - 1]
    }
  }
}
</script>

<style lang="css" scoped>
.cover {
  opacity: 0.2;
}
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.list-group-item {
  padding: 5px 5px;
  white-space: nowrap;
  font-size: 11px;
  border: 1px solid #eee !important;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin: -36%;
}
#img-frame img {
  object-fit: contain;
  width: 20%;
  height: 20%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
fieldset {
  border: none;
  padding: 0 !important;
}
@media screen and (min-width: 320px) and (max-width: 1024px) {
    .list-group-item {
        font-size: 9px;
    }
}
@media screen and (min-width: 1025px) and (max-width: 1280px) {
    .list-group-item {
        font-size: 11px;
    }
}
@media all and (min-width: 1281px) {
}
</style>
